import { render, staticRenderFns } from "./ImagensAnexoCPP.vue?vue&type=template&id=bda41624&scoped=true"
import script from "./ImagensAnexoCPP.vue?vue&type=script&lang=js"
export * from "./ImagensAnexoCPP.vue?vue&type=script&lang=js"
import style0 from "./ImagensAnexoCPP.vue?vue&type=style&index=0&id=bda41624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda41624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VCol,VImg,VRow})
